/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
if (!customElements.get('orfelie-availability')) {
  class OrfelieAvailability extends HTMLElement {
    connectedCallback() {
      this.onVariantChanged = (event) => {
        const section = this.closest('[data-section-id]');
        const origin = event.target instanceof Element ? event.target.closest('[data-section-id]') : null;
        if (section && origin && section !== origin) return;
        const variant = event.detail && event.detail.variant;
        const id = variant ? String(variant.id) : '';
        const template = Array.from(this.querySelectorAll('template[data-variant-id]')).find((item) => item.dataset.variantId === id);
        if (variant && !template) return;
        const status = this.querySelector('[data-availability-status]');
        if (status && template) status.textContent = template.content.textContent.trim();
        if (status && !variant) status.textContent = this.dataset.unavailable || '';
      };
      document.addEventListener('variant:changed', this.onVariantChanged);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariantChanged);
    }
  }
  customElements.define('orfelie-availability', OrfelieAvailability);
}
